module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_sns_04-b5efa2ba27b49d74e513283f8dbe6169.jpg";